import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRANSACTIONS_QUERY_KEY } from "./useTransactions";
import { ANALYTICS_QUERY_KEY } from "./useSummary";

type TransactionResponse = components["schemas"]["TransactionResponse"];

export type RestoreTransactionVariables = {
  transactionId: string;
};

export function useRestoreTransaction() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TransactionResponse, Error, RestoreTransactionVariables>({
    mutationFn: async ({ transactionId }) => {
      const { data, error } = await client.POST(
        "/api/transactions/{transaction_id}/restore",
        { params: { path: { transaction_id: transactionId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to restore transaction ${transactionId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRANSACTIONS_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ANALYTICS_QUERY_KEY });
    },
  });
}
